import React from 'react'; 
import PropTypes from 'prop-types'

import Button from '../../elements/Button';
import Image from './Image';

import './style.scss';

function HomeHero(props) {
	const { title, titleWords, description, buttons } = props; 
    let split_title = title.split("  "); 

	return(
		<div className="home-hero-container">
			<div className="home-hero g-0">
					<div className="home-hero-text-buttons">
						<h1>
              { split_title.map((line, i) => {
                return (<React.Fragment key={line}>{line} { i ==0 && <br /> }</React.Fragment>)
              })}
              <div className="rotating-words">
                { titleWords.map((word) => {
                  return(<span key={word.word} className="rotating-word">{word.word}</span>)
                })}
              </div>
						</h1>

            <p className="hero-text">
              {description} 
            </p>

            <div>
              {buttons.map((button) => (
                <Button key={button.text} src={button.link} value={button.text} option={button.option} disableArrowShift="true" />
              ))}
            </div>
					</div>
          <Image />
        
			</div>
		</div>
	) 
}

HomeHero.propTypes = { 
  title: PropTypes.string.isRequired, 
  description: PropTypes.string.isRequired, 
  buttons: PropTypes.array.isRequired,
}; 

export default HomeHero; 
